import { FC } from 'react'
import { Tabs } from 'antd'
import shallow from 'zustand/shallow'
import { useAuth } from '../../../context/auth-context'
import { CompanySettingsTabs } from '../types'
import { getCompanySettingsPermissionInfo } from '../../../shared/permissions/permission-helper'
import { CompanySettingsPermissions } from '../permissions'
import useIsFeatureEnabled from '../../../graphql/featureToggle/useIsFeatureEnabled'
import { FeatureNameEnum } from '../../../graphql/featureToggle/FeatureNameEnum'
import { CompanySettingsPyramidsTab } from '../pyramids/CompanySettingsPyramidsTab'
import { useHRSettingsStore } from './HRSettingsStore'
import { HRSettingsCultivatingTalentsTab } from '../cultivatingTalents/HRSettingsCultivatingTalentsTab'
import { HRSettingsTargetsReportsTab } from '../targetReports/HRSettingsTargetsReportsTab'
import { HRSettingsAppraisalSeasonTab } from './HRSettingsAppraisalSeasonTab'

const { TabPane } = Tabs

export const HRSettingsContent: FC = () => {
  const { user } = useAuth()
  const [activeTab] = useHRSettingsStore((state) => [state.activeTab], shallow)
  const { isFeatureEnabled: rankingPhaseTwoEnabled } = useIsFeatureEnabled(FeatureNameEnum.TALENTS_SEASON)

  const companySettingsPermissionInfo = getCompanySettingsPermissionInfo(user.roles ? user.roles : [])

  return (
    <Tabs activeKey={activeTab} renderTabBar={() => <></>}>
      {companySettingsPermissionInfo[CompanySettingsPermissions.appraisalSeasonTab] && (
        <TabPane key={CompanySettingsTabs.appraisalSeason}>
          <HRSettingsAppraisalSeasonTab />
        </TabPane>
      )}

      {companySettingsPermissionInfo[CompanySettingsPermissions.pyramidsTab] && (
        <TabPane key={CompanySettingsTabs.pyramids}>
          <CompanySettingsPyramidsTab />
        </TabPane>
      )}

      {companySettingsPermissionInfo[CompanySettingsPermissions.cultivatingTalentsTab] && !!rankingPhaseTwoEnabled && (
        <TabPane key={CompanySettingsTabs.cultivatingTalents}>
          <HRSettingsCultivatingTalentsTab />
        </TabPane>
      )}

      {companySettingsPermissionInfo[CompanySettingsPermissions.targetReportsTab] && (
        <TabPane key={CompanySettingsTabs.targetReports}>
          <HRSettingsTargetsReportsTab />
        </TabPane>
      )}
    </Tabs>
  )
}
